import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlidadeConfigModel } from '../../../core/services/models/alidade-config.model';
import { ApiResponseModel } from '../../../shared/models/api-response.model';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class DisplayLogicService {
  private readonly apiUrl: string;

  constructor(
    @Inject('ALIDADE_CONFIG') config: AlidadeConfigModel,
    private http: HttpClient,
    private store: Store,
  ) {
    this.apiUrl = `${config.apiURL}/builder`;
  }

  /* block expressions - start */
  addExpressionToBlock(
    blockIdobject: number,
    type: number,
    index: number,
  ): Observable<ApiResponseModel<{ idobject: number }[]>> {
    return this.http.post<ApiResponseModel<{ idobject: number }[]>>(
      `${this.apiUrl}/blocks/${blockIdobject}/expressions`,
      {
        type,
        index,
      },
    );
  }

  /* block expressions - end */

  /* question expressions - start */
  addExpressionToQuestion(
    questionIdobject: number,
    type: number,
    index: number,
  ): Observable<ApiResponseModel<{ idobject: number }[]>> {
    return this.http.post<ApiResponseModel<{ idobject: number }[]>>(
      `${this.apiUrl}/questions/${questionIdobject}/expressions`,
      {
        type,
        index,
      },
    );
  }

  /* question expressions - end */

  /* choice expressions - start */
  addExpressionToChoice(
    choiceIdobject: number,
    type: number,
    index: number,
  ): Observable<ApiResponseModel<{ idobject: number }[]>> {
    return this.http.post<ApiResponseModel<{ idobject: number }[]>>(
      `${this.apiUrl}/choices/${choiceIdobject}/expressions`,
      {
        type,
        index,
      },
    );
  }

  /* choice expressions - end */
}
